import React from 'react'
import Style from './index.module.less'
import { getMoney } from '@hlj/hlj-utils'

export default ({ item, onChange, checked }) => {
  const { price, actual_price, market_price, title, cover_path } = item
  return (
    <div className={Style.area}>
      {/* <Checkbox
      className={Style.checkbox}
      checked={checked}
      onChange={e => onChange(item)}
    /> */}
      <img className={Style.img} src={`${cover_path}?imageView2/2/w/160`} />
      <h3 className={Style.title}>{title}</h3>
      {price && (
        <p>
          <em>{getMoney(actual_price)}</em>
          <i>{getMoney(market_price)}</i>
        </p>
      )}
    </div>
  )
}
